import type { UiNode, UiNodeInputAttributes } from "@ory/kratos-client";
import type { FormEvent, MouseEvent } from "react";
import type { NodeQuery } from "~/components/KratosFlow/Flow";

export type ValueSetter = (
	value: string | number | boolean | undefined,
) => Promise<void>;

export type FormDispatcher = (
	e: FormEvent<HTMLFormElement> | MouseEvent,
) => Promise<void>;

export interface NodeInputProps {
	node: UiNode;
	attributes: UiNodeInputAttributes;
	// biome-ignore lint/suspicious/noExplicitAny: any is required for the validate function
	value: any;
	disabled: boolean;
	dispatchSubmit: FormDispatcher;
	setValue: ValueSetter;
}

export const matchFlowQuery = (node: UiNode, query: NodeQuery): boolean =>
	Object.entries(query).every(([key, value]) => {
		if (!Object.hasOwn(node.attributes, key)) {
			return false;
		}
		return Object.entries(node.attributes).some(([attrKey, attrValue]) => {
			if (key !== attrKey) return false;
			return value === attrValue;
		});
	});
